import {Component} from "@angular/core";
import {TaxSearchModel} from "../tax-search.model";
import {TaxEntityModel} from "../tax-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-tax-search-page",
    templateUrl: "./tax-search-page.component.html",
    providers: [provideSearchModel(TaxSearchModel), provideEntityModel(TaxEntityModel)]
})
export class TaxSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
